export const BaseAppRoutes = {
  login: '/auth/login',
  register: '/auth/register',
  invite: '/auth/registration/invite/',
  emasters: '/auth/login?network=emasters',
} as const;

export type BaseAppRoutesType = typeof BaseAppRoutes[keyof typeof BaseAppRoutes];
